import { render, staticRenderFns } from "./DetailFooter.vue?vue&type=template&id=4975de9e&"
import script from "./DetailFooter.vue?vue&type=script&lang=js&"
export * from "./DetailFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports